<template>
  <v-dialog v-model="openComponente" persistent width="800px" content-class="">
    <v-card>
      <!-- cabecera del dialogo -->
      <v-toolbar dark class="datModalTitleContainer">
        <v-toolbar-title>
          {{ informeComponente.nombre }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="fCerrarVentana()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-dialog v-model="dLoading" hide-overlay persistent width="300">
        <v-card class="datModalTitleContainer" dark>
          <v-card-text>
            {{ $t('cargandoContenido') }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-flex xs12 class="pl-2 datModalSubtitle mb-3">
            {{ informeComponente.descripcion }}
          </v-flex>
          <v-layout row wrap justify-space-between>
            <v-flex xs12 sm6>
              <v-menu bottom :nudge-width="250" :nudge-left="0" class="data-MenuRiesgo">
                <v-btn flat slot="activator" style='text-transform:lowerCase'>
                  {{ selectedCLTE.length }} {{ this.$t('clientesSeleccionados') }}
                  <v-icon>keyboard_arrow_down</v-icon>
                </v-btn>

                <v-card class="mt-5" v-if="selectedCLTE.length > 0">
                  <div class="text-xs-left pa-2"
                    :style="(selectedCLTE.length > 20) ? 'max-width:750px' : 'max-width:500px'">
                    <v-chip v-for="(cliente, index) in selectedCLTE" v-bind:key="cliente.cliente" label
                      color="datSecondary" text-color="white" close @input="fDeleteClientSelect(cliente, index)">
                      {{ cliente.nombre }}
                    </v-chip>
                  </div>
                </v-card>
                <v-card class="mt-5" v-if="selectedCLTE.length === 0">
                  <div class="text-xs-left pa-3" style="max-width:300px">
                    {{ $t("debeSeleccionar") }}
                  </div>
                </v-card>
              </v-menu>

            </v-flex>
            <v-flex xs12 sm4>
              <!-- buscador -->
              <v-text-field color="datPrimary" append-icon="search" @click:append="buscar" v-model="searchCLTE"
                :label="this.$t('buscar')"
                style="padding-top: 6px !important;margin-top: 0px !important;"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm12 px-3 mt-1>
              <v-data-table height="inherit" :headers="headersCLTE" :items="clientes"
                :no-data-text="this.$t('noResultados')" :no-results-text="this.$t('noResultados')"
                v-bind:pagination.sync="paginationCLTE" :loading="loadingCLTE" :total-items="totalItemsCLTE"
                :rows-per-page-items="rowsPerPageArrayCLTE" sm12 class="mt-1 mb-4" select-all v-model="selectedCLTE">
                <template slot="headers" slot-scope="props">
                  <tr class="data-gbGreyLight">
                    <th id="selectAll">
                      <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate" hide-details
                        @change="toggleAll" v-model="dSelectAllElements"></v-checkbox>
                    </th>
                    <th class="text-xs-left " v-for="header in props.headers" :key="header.text" :id="header.value"
                      :class="['column sortable', paginationCLTE.descending ? 'desc' : 'asc', header.value === paginationCLTE.sortBy ? 'active' : header.class, 'text-xs-' + header.align + ' ' + header.class + ' ']"
                      @click="cambiaOrden(header.value)">
                      <v-icon v-if="header.sortable">arrow_upward</v-icon>
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <tr :active="props.selected">
                    <td>
                      <v-checkbox :input-value="props.selected" color="datSecondary" hide-details
                        @change="fChangeSelectedItem(props)"></v-checkbox>
                    </td>
                    <td class="text-xs-left">{{ props.item.cliente }}</td>
                    <td class="text-xs-left">{{ props.item.nombre }}</td>
                  </tr>
                </template>

              </v-data-table>
            </v-flex>
          </v-layout>

        </v-card-text>
        <v-card-actions class="py-3 transparent">
          <v-flex xs12 pr-3 class="text-xs-right">
            <v-btn class="datPrimaryBtnOut" flat @click="limpiaFiltros()">{{ $t('limpiar') }}</v-btn>
            <v-btn class="datPrimaryBtn" flat @click="descargarInforme()" :disabled="disableDescarga">
              {{ descargarTxt }}
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>

import { generarPdf, abrirPestanaEnBlanco, abrirPdfEnPestanaPreabierta } from '@/utils/utilDescargarPdf'
import ServiceRecogidasEntregas from '@/services/srv-recogidas-entregas'
import SrvGeneral from '@/services/srv-general'

export default {
  name: 'ShpFiltroBaseInformes',
  components: {
  },
  props: {
    pInformeComponente: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dSelectAllElements: false,
      dInterval: {},
      clientes: [],
      headersCLTE: [
        {
          text: this.$t('cliente'),
          align: 'left',
          value: 'cliente',
          sortable: false
        },
        {
          text: this.$t('nombre'),
          align: 'left',
          value: 'nombre',
          sortable: false
        }
      ],
      dLoading: false,
      searchCLTE: '',
      loadingCLTE: false,
      openComponente: true,
      totalItemsCLTE: 0,
      rowsPerPageArrayCLTE: [8],
      disableDescarga: false,
      rowsPerPage: 8,
      timerSearchCLTE: null,
      selectedCLTE: [],
      descargarTxt: this.$t('descargar'),
      paginationCLTE: { 'sortBy': 'cliente', 'descending': false, 'rowsPerPage': 8 },
      valid: true,
      dEventoAlerta: 'evento-mostrarAvisos'
    }
  },
  watch: {
    selectedCLTE: {
      handler() {
      }
    },
    searchCLTE: {
      handler() {
        clearInterval(this.timerSearchCLTE)
        this.timerSearchCLTE = setTimeout(function () {
          this.buscar()
        }.bind(this), 500)
      }
    },
    // control cambio informe
    pInformeComponente: {
      handler() {
        // si cambia de informe
        this.informeComponente = this.pInformeComponente
      }
    },
    paginationCLTE: {
      handler() {
        this.cargaClientes(this.paginationCLTE.sortBy, this.paginationCLTE.descending, this.paginationCLTE.page, this.paginationCLTE.rowsPerPage, this.searchCLTE, [])
      },
      deep: true
    }
  },
  created() {
    // Inicializa las variables locales
    this.informeComponente = this.pInformeComponente
  },
  beforeDestroy() {

  },
  methods: {
    /**
     * selecciona y deselecciona un elemento
     */
    fChangeSelectedItem(props) {
      props.item.selected = !props.item.selected
      if (props.item.selected) {
        let existeCliente = false
        for (let i = 0; i < this.selectedCLTE.length; i++) {
          const itemTemp = this.selectedCLTE[i]
          if (itemTemp.cliente === props.item.cliente) {
            existeCliente = true
            break
          }
        }
        if (!existeCliente) {
          this.selectedCLTE.push(props.item)
        }
      } else {
        this.selectedCLTE.map((selectedCLTE, index) => {
          if (selectedCLTE.cliente === props.item.cliente) {
            this.selectedCLTE.splice(index, 1)
          }
        })
      }
      this.updateSelectAll()
    },
    toggleAll() {
      if (!this.dSelectAllElements) {
        this.unSelectAll()
      } else {
        this.selectAll()
      }
    },
    /**
     * Borra un elemento de la lista de elementos
     */
    fDeleteClientSelect(cliente, index) {
      cliente.selected = false
      this.selectedCLTE.splice(index, 1)
      this.updateSelectAll()
    },
    /**
     * Borra un elemento de la lista de elementos
     */
    updateSelectAll() {
      let allUnselected = true
      for (let j = 0; j < this.clientes.length; j++) {
        const itemTemp2 = this.clientes[j]
        if (itemTemp2.selected) {
          allUnselected = false
          break
        }
      }
      if (allUnselected) {
        this.dSelectAllElements = false
      }
    },
    /**
     * Borra un elemento de la lista de elementos
     */
    selectAll() {
      for (var k = 0; k < this.clientes.length; k++) {
        let existeCliente = false
        const cliente = this.clientes[k]
        for (var m = 0; m < this.selectedCLTE.length; m++) {
          const clienteCLTE = this.selectedCLTE[m]
          if (cliente.cliente === clienteCLTE.cliente) {
            existeCliente = true
            break
          }
        }
        if (!existeCliente) {
          cliente.selected = true
          this.selectedCLTE.push(cliente)
        }
      }
    },
    /**
     * Borra un elemento de la lista de elementos
     */
    unSelectAll() {
      const indexDeleteCLTE = []
      for (var i = 0; i < this.clientes.length; i++) {
        const cliente = this.clientes[i]
        for (var j = 0; j < this.selectedCLTE.length; j++) {
          const clienteCLTE = this.selectedCLTE[j]
          if (cliente.cliente === clienteCLTE.cliente) {
            cliente.selected = false
            indexDeleteCLTE.push(j)
            break
          }
        }
      }
      indexDeleteCLTE.slice().sort(function (a, b) {
        return b - a
      })
      for (var s = 0; s < indexDeleteCLTE.length; s++) {
        const indexDelete = indexDeleteCLTE[s]
        this.selectedCLTE.splice(indexDelete - s, 1)
      }
    },
    /**
     * Metodo para cerrar la ventana
     */
    fCerrarVentana() {
      this.limpiaFiltros()
      this.$emit('close')
    },
    /**
     * Metodo de limpieza de los filtros
     */
    limpiaFiltros() {
      this.selectedCLTE = []
      this.clientes.map((cliente, index) => {
        cliente.selected = false
      })
      this.searchCLTE = ''
      this.paginationCLTE = { 'sortBy': 'cliente', 'descending': false, 'rowsPerPage': 8, 'page': 1 }
      this.dSelectAllElements = false
    },
    /*
     * cambia el orden de an columna
     */
    cambiaOrden(column) {
      this.paginationCLTE.page = 1
      this.paginationCLTE.rowsPerPage = this.rowsPerPage
      if (this.paginationCLTE.sortBy === column) {
        this.paginationCLTE.descending = !this.paginationCLTE.descending
      } else {
        this.paginationCLTE.sortBy = column
        this.paginationCLTE.descending = false
      }
    },
    /*
     * Busca los informes ue puede mostrar
     */
    buscar() {
      this.paginationCLTE = { 'sortBy': 'cliente', 'descending': false, 'rowsPerPage': 8, 'page': 1 }
      this.cargaClientes(this.paginationCLTE.sortBy, this.paginationCLTE.descending, this.paginationCLTE.page, this.paginationCLTE.rowsPerPage, this.searchCLTE, [])
    },
    /*
     * Metodo de carga de usuarios
     */
    cargaClientes(sortBy, descending, page, rowsPerPage, search, filters) {
      this.loadingCLTE = true;
      this.filters = filters || [];

      // Definir ordenamiento
      let orderDirection = descending ? 'DESC' : 'ASC';
      const orderBy = sortBy || 'cliente';
      if (!sortBy) {
        orderDirection = 'ASC';
      }

      // Definir paginación
      const currentPage = page || 1;
      const rows = rowsPerPage || this.paginationCLTE.rowsPerPage;
      const offset = rows * (currentPage - 1) + 1;

      // Construir JSON de entrada
      const jsonEntrada = {
        tira: this.$store.getters.getAutenticacion.tira,
        usuario: this.$store.getters.getAutenticacion.usuario,
        empresa: this.$store.getters.getAutenticacion.empresa,
        estadoAP: 'A',
        searchCols: 'cliente,nombre',
        offset: offset,
        numRows: rows,
        orderBy: orderBy,
        order: orderDirection,
        filters: this.filters
      };

      // Manejar búsqueda según origen
      if (localStorage.getItem('isOnPremise') === 'yes') {
        jsonEntrada.search = search;
      } else {
        jsonEntrada.searchClienteIdentFiscalNombreRazonSocial =
          search ? `%${search}%` : '%%%';
      }

      // Llamada al servicio
      SrvGeneral.lovClte(jsonEntrada)
        .then(response => {
          const datosClientes = response.data;
          this.clientes = datosClientes.numReg > 0 ? datosClientes.dataRes : [];

          let numSelected = 0;
          this.clientes.forEach(cliente => {
            cliente.selected = false;
            this.selectedCLTE.forEach(selected => {
              if (cliente.cliente === selected.cliente) {
                cliente.selected = true;
                numSelected++;
              }
            });
          });

          this.totalItemsCLTE = datosClientes.numReg;
          this.dSelectAllElements = (numSelected === this.paginationCLTE.rowsPerPage);
          this.loadingCLTE = false;
          this.numValidacionesValue = 0;
          this.buscarTxt = this.$t('buscar');
        })
        .catch(error => {
          const data = (error.response && error.response.data) || {};
          const errorPortal = data.statusText || data.exception || data.errorMsg || 'Error desconocido';
          console.error("error", data);
          this.$emit('alert', '<b>carga pedidos</b><br> ' + errorPortal);
        });
    },
    /**
     * Metodo de descarga del informes
     */
    descargarInforme() {
      const ventanaPdf = abrirPestanaEnBlanco()
      this.descargarTxt = this.$t('descargar')
      this.dLoading = true
      this.disableDescarga = true
      this.descargandoInforme()
      // prepara los parametros generales de busqueda
      const jsonEntrada = {
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        tipoEmpresa: '0',
        pdfSn: 'S',
        verEspecialesSN: 'S',
        verAvalesSN: 'S',
        verObservSN: 'S',
        verDotacionSN: 'S',
        verAnualSN: 'S',
        verMensualSN: 'S',
        verBalanceOficSN: 'S',
        verInformeComercSN: 'S',
        estadoClteAPT: 'T',
        listaClientes: [],
        listaClavesCredito: []
      }
      if (this.selectedCLTE.length > 0) {
        jsonEntrada.listaClientes = []
        for (var i = 0; i < this.selectedCLTE.length; i++) {
          const clienteTemp = this.selectedCLTE[i]
          const objectTemp = { 'codigoCliente': clienteTemp.cliente }
          jsonEntrada.listaClientes.push(objectTemp)
        }
      }

      ServiceRecogidasEntregas.carteraRiesgosCliente(jsonEntrada).then(response => {
        if (response.data.statusCode === '200') {
          if (response.data.errorCode === undefined) {
            if (response.data.report !== '') {
              abrirPdfEnPestanaPreabierta(generarPdf(response.data.report), ventanaPdf)
              this.numValidacionesValue = 0
            } else {
              if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
              this.$emit('alert', '<b>' + this.$t('estadoVentaNotFound') + '</b><br/>' + this.$t('estadoVentaNotFoundDesc'))
            }
            this.dLoading = false
            this.disableDescarga = false
            this.descargarTxt = this.$t('descargar')
          } else {
            if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
            this.dLoading = false
            this.disableDescarga = false
            this.descargarTxt = this.$t('descargar')
            this.$emit('alert', '<b>descarga informe de Riesgos</b><br> ' + response.data.errorMsg)
          }
        } else {
          if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
          this.dLoading = false
          this.disableDescarga = false
          this.descargarTxt = this.$t('descargar')
          this.$emit('alert', '<b>descarga informe de</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        if (ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
        let errorPortal = ''
        if (error.response.data.statusText !== undefined) {
          errorPortal = error.response.data.statusText
        }
        if (error.response.data.exception !== undefined) {
          errorPortal = error.response.data.exception
        }
        if (error.response.data.errorMsg !== undefined) {
          errorPortal = error.response.data.errorMsg
        }
        this.$emit('alert', '<b>descarga informe de</b><br> ' + errorPortal)
        this.dLoading = false
        this.disableDescarga = false
        this.descargarTxt = this.$t('descargar')
      })
    },
    /*
     * Metodo de descargando
     */
    descargandoInforme() {
      this.disableDescarga = true
      this.descargarTxt = this.$t('enPreparacion')
    },
    pausaDescargaInforme() {
      if (this.numValidacionesValue !== 20) {
        this.numValidacionesValue = this.numValidacionesValue + 1
        this.descargarTxt = this.$t('validando') + '...'
        this.dInterval = setInterval(() => {
          clearInterval(this.dInterval)
          this.descargarInforme()
        }, 500)
      } else {
        this.descargarTxt = this.$t('descargar')
        this.numValidacionesValue = 0
        this.$emit('alert', this.$t('reviseFiltros'))
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.data-MenuRiesgo .v-menu__content {
  box-shadow: none !important;
}

.buttonBar .card__title {
  padding: 8px !important;
}

.buttonBarSearch .card__title {
  padding: 0px !important;
}

.buttonBarSearchTop .card__text {
  padding-top: 4px !important;
  padding-bottom: -10px !important;
}

.numberInputSpinnerInput .vnis__input {
  background: #ffffff !important;
  border: 0px !important;
  border-bottom: 1px solid #999999 !important;
}

.numberInputSpinnerButton .vnis__button {
  background: #ffffff !important;
  color: #000000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Informes/Riesgos/ShpFiltroRiesgos.vue